import React from "react";
import '../../styles/Home.css';
import heroLogo from '../../assets/images/heroLogo.svg';
import { useTypewriter, Cursor } from "react-simple-typewriter";
import { AiOutlineGithub, AiOutlineInstagram, AiOutlineLinkedin } from 'react-icons/ai';

const Home = () => {
  const [text] = useTypewriter({
    words: ["Front End Developer", "Cyber Security Researcher"],
    loop: {},
    typeSpeed: 80,
    deleteSpeed: 50,
  });
  return (
    <>
     <div className="home">
      <div className="heroPage">
        <div className="introName">
          <h2>Hi There!
          <span className="wave" role="img" aria-labelledby="wave">👋🏻</span>
          <p>I'm <span className="highlight">Karthikgohul</span></p>
          </h2>
          <div className="typeWriting">
          {text}<Cursor/>
          </div>
        </div>
        <img src={heroLogo} alt="Hero Logo"/>
      </div>
      <div className="myDetails">
        <div className="whoami">
        <h2>WHO AM I</h2>
        <ul>
            <li>I recently graduate <span>Computer Science Engineer</span> with CGPA 8.7/10.</li>
            <li>Skilled professional with expertise in <span>front-end development</span> and <span>cybersecurity research</span>.</li>
            <li>I also learning new technologies like <span>React Js</span>, Design Principle.</li>
          </ul>
      </div>
      <div className="connectMe">
        <h3>CONNECT ME ON</h3>
        <div className="introIcon">
          <a href="https://github.com/karthikgohul/" target="_blank" rel="noreferrer"><AiOutlineGithub /></a>
          <a href="https://www.linkedin.com/in/karthikgohul-anandhakumar/" target="_blank" rel="noreferrer"><AiOutlineLinkedin /></a>
          <a href="https://www.instagram.com/karthik_gohul/" target="_blank" rel="noreferrer"><AiOutlineInstagram /></a>
        </div>
      </div>
      </div>
     </div>
    </>
  )
}

export default Home;